<template>
  <div class="head">
    <div class="main">
      <Logo class="tlogo" />
      <div class="rpart">
        <div class="menu">
          <ul>
            <li @click="go('home')">
              <a :class="$route.meta =='home' ?'a1-c ':'a1'">{{ $t('menu.home') }}</a>
            </li>

            <li @click="go('skill')">
              <a class="a1">技术</a>
            </li>
            <li>
              <Poptip
                placement="bottom"
                width="180"
                trigger="hover"
                class="tip1"
              >
                <a :class="$route.meta =='product' ?'a1-c ':'a1'">产品</a>
                <div
                  class="child"
                  slot="content"
                >
                  <div class="left">
                    <div class="item">
                      <p>底层架构</p>
                      <a @click="goPro('platform')">底层核心平台</a>
                      <!-- <a @click="goPro('hwl')">恒为链</a> -->
                      <a @click="goPro('CoChain')">Co-Chain</a>
                    </div>
                    <div class="item">
                      <p>开发者工具</p>
                      <a
                        href="https://developers.hwelltech.com/"
                        target="view_window"
                      >开发者平台</a>
                      <a @click="goPro('DataAPI')">Data-API</a>
                    </div>
                    <div class="item">
                      <p>区块链云服务</p>
                      <a @click="goPro('baas')">恒为Baas平台</a>
                    </div>
                  </div>
                  <div class="right">
                    <div class="item">
                      <p>区块链运维</p>
                      <a
                        href="https://explorer.hwelltech.com/"
                        target="view_window"
                      >区块链浏览器</a>
                      <a @click="goPro('operation')">区块链运维监控平台</a>
                      <a @click="goPro('gateway')">存证服务前置网关</a>
                    </div>
                    <div class="item">
                      <p>数字资产</p>
                      <a @click="goPro('digitization')">资产数字化平台</a>
                      <a @click="goPro('toolkit')">数字资产工具包</a>
                    </div>
                  </div>
                </div>
              </Poptip>
            </li>

            <li>
              <Poptip
                placement="bottom"
                width="180"
                trigger="hover"
                class="tip2"
              >
                <a :class="$route.meta =='solution' ?'a2-c ':'a2'">解决方案</a>
                <div
                  class="child"
                  slot="content"
                >
                  <div class="left">
                    <div class="item">
                      <p>金融+区块链</p>
                      <a @click="goSol('onlineTrad')">区块链线上交易平台</a>
                      <a @click="goSol('pointsMall')">区块链积分商城</a>
                      <a @click="goSol('asset')">区块链证券交易平台</a>
                      <a @click="goSol('clear')">区块链清结算平台</a>
                      <a @click="goSol('supplyChain')">区块链供应链金融平台</a>
                    </div>
                    <div class="item">
                      <p>医疗+区块链</p>
                      <a @click="goSol('vaccine')">区块链疫苗溯源平台</a>
                      <a @click="goSol('medicalCare')">区块链处方流转平台</a>
                      <a @click="goSol('classification')">区块链分级诊疗平台</a>

                    </div>

                  </div>
                  <div class="right">
                    <div class="item">
                      <p>农业+区块链</p>
                      <a @click="goSol('agriculture')">区块链农渔产品溯源平台</a>
                    </div>
                    <div class="item">
                      <p>政务+区块链</p>
                      <a @click="goSol('government')">区块链数据治理监管平台</a>
                      <a @click="goSol('countryside')">区块链农村三资监管平台</a>
                    </div>
                    <!-- <div class="item">
                      <p>数字资产</p>
                      <a @click="goSol('digitization')">资产数字化平台</a>
                      <a @click="goSol('toolkit')">数字资产工具包</a>
                    </div>  -->
                  </div>
                </div>
              </Poptip>
            </li>
            <li @click="go('newslist')">
              <a :class="$route.meta =='newslist' ?'a2-c ':'a2'">{{ $t('menu.message') }}</a>
            </li>
            <li @click="go('aboutUs')">
              <a :class="$route.meta =='aboutUs' ?'a2-c':'a2'">{{ $t('menu.aboutUs') }}</a>
            </li>
            <li @click="go('joinUs')">
              <a :class="$route.meta =='joinUs' ?'a2-c':'a2'">加入我们</a>
            </li>
            <!-- <li class="prod">
              <Poptip placement="bottom" width="180" trigger="hover">
                <p class="p1" :class="$route.meta =='service' ?'a-cur':''">{{ $t('menu.service') }}</p>
                <a class="a">
                  <div :class=" lang == 'cn' ?  'overcn  over' :'overen  over'  "></div>
                </a>
                <div class="api" slot="content">
                  <p>
                    <a @click="go('product')">{{ $t('menu.product') }}</a>
                  </p>
                  <p>
                    <a @click="go('products')">{{ $t('menu.products') }}</a>
                  </p>
                  <p>
                    <a @click="go('developer')">{{ $t('menu.developer') }}</a>
                  </p>
                  <p>
                    <a @click="go('browser')">{{ $t('menu.browser') }}</a>
                  </p>
                </div>
              </Poptip>
            </li> -->
          </ul>
        </div>
      </div>
      <!-- <div class="lang">
        <p
          class="langcn"
          @click="handleLang"
          v-show="cn"
        >
          <span class="cn">中</span>

          <span class="xg">/</span>

          <span class="en">EN</span>
        </p>
        <p
          class="langen"
          @click="handleLang"
          v-show="en"
        >
          <span class="cn">中</span>

          <span class="xg">/</span>

          <span class="en">EN</span>
        </p>
      </div> -->
    </div>
  </div>
</template>

<script>
import Logo from "./Logo";
import { Dropdown, DropdownMenu, DropdownItem, Icon, Poptip } from "iview";
import { list } from "../../lang";

export default {
  inject: ["reload"],
  name: "Head",
  components: {
    Logo,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Icon,
    Poptip,
  },
  data() {
    return {
      langList: list,
      cn: false,
      en: false,
      lang: "",
    };
  },

  created() {
    this.getLang();
  },

  methods: {
    jump(url, target) {
      if (target == "self") {
        this.$router.push(url);
      } else {
        window.open("https://developers.hwelltech.com");
      }
    },

    handleLang() {
      if (this.$i18n.locale == "cn") {
        this.$i18n.locale = "en";
        localStorage.setItem("Lang", "en");
      } else {
        this.$i18n.locale = "cn";
        localStorage.setItem("Lang", "cn");
      }
      this.reload();
    },
    getLang() {
      if (this.$i18n.locale == "en") {
        this.en = true;
        this.lang = "en";
      } else {
        this.cn = true;
        this.lang = "cn";
      }
    },
    //跳转
    go(name) {
      if (name == "home") {
        this.$router.push("/");
      } else if (name == "solution") {
        this.$router.push("/solution/999");
      } else if (name == "newslist") {
        this.$router.push("/newslist");
      } else if (name == "aboutUs") {
        this.$router.push("/aboutUs");
      } else if (name == "joinUs") {
        this.$router.push("/joinUs");
      } else if (name == "skill") {
        if (this.$route.meta == "home") {
          this.$emit('info',2)
        } else {
          this.$router.push({
            path: "/?#skill",
          });
        }
      }
    },

    //产品跳转
    goPro(name) {
      if (name == "platform") {
        this.$router.push("/product/platform");
      } else if (name == "hwl") {
        this.$router.push("/product/hwl");
      } else if (name == "CoChain") {
        this.$router.push("/product/CoChain");
      } else if (name == "DataAPI") {
        this.$router.push("/product/DataAPI");
      } else if (name == "baas") {
        this.$router.push("/product/baas");
      } else if (name == "operation") {
        this.$router.push("/product/operation");
      } else if (name == "gateway") {
        this.$router.push("/product/gateway");
      } else if (name == "digitization") {
        this.$router.push("/product/digitization");
      } else if (name == "toolkit") {
        this.$router.push("/product/toolkit");
      }
    },

    //解决方案跳转
    goSol(name) {
      if (name == "agriculture") {
        this.$router.push("/solution/agriculture");
      } else if (name == "onlineTrad") {
        this.$router.push("/solution/onlineTrad");
      } else if (name == "pointsMall") {
        this.$router.push("/solution/pointsMall");
      } else if (name == "asset") {
        this.$router.push("/solution/asset");
      } else if (name == "clear") {
        this.$router.push("/solution/clear");
      } else if (name == "supplyChain") {
        this.$router.push("/solution/supplyChain");
      } else if (name == "vaccine") {
        this.$router.push("/solution/vaccine");
      } else if (name == "medicalCare") {
        this.$router.push("/solution/medicalCare");
      } else if (name == "government") {
        this.$router.push("/solution/government");
      } else if (name == "classification") {
        this.$router.push("/solution/classification");
      } else if (name == "countryside") {
        this.$router.push("/solution/countryside");
      }
    },
  },
};
</script>

<style scoped lang="less">
@import url("../../assets/css/var.less");
.head {
  min-width: @min-width;
  position: absolute;
  width: 100%;
  height: 70px;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0%);
  background: #fff;
  z-index: 1;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  .main {
    margin: 0 auto;
    display: flex;
    height: 70px;
    .tlogo {
      display: inline-block;
      line-height: 70px;
      height: 70px;
      width: 240px;
    }
    .rpart {
      display: inline-block;
      text-align: right;
      flex: 1;
      margin-left: 160px;
      .menu {
        display: inline-block;
        vertical-align: middle;
        text-align: center;
        height: 70px;
        ul {
          width: 100%;
          display: inline-block;
          li {
            float: left;
            list-style: none;
            cursor: pointer;

            display: block;
            height: 70px;
            margin: 0 20px;
            a {
              display: block;
              position: relative;
              height: 70px;
              line-height: 70px;
              font-size: 14px;
              font-weight: 400;
              color: #444444;

              &.a1-c {
                color: #2a93ff;
                &::before {
                  .oo();
                  left: 5px;
                  bottom: -8px;
                }
              }
              &.a2-c {
                color: #2a93ff;
                &::before {
                  .oo();
                  left: 18px;
                  bottom: -8px;
                }
              }
            }

            .a1 {
              transition: all 0.3s linear;
              &::before {
                .oo();
                transform: translate(5px, 8px) scale(0, 0);
              }
            }
            .a2 {
              transition: all 0.3s linear;
              &::before {
                .oo();
                transform: translate(18px, 8px) scale(0, 0);
              }
            }
            &:hover {
              .a1 {
                color: #2a93ff;
                &::before {
                  transition: all 0.3s linear;
                  transform: translate(5px, 8px) scale(1, 1);
                }
              }
              .a2 {
                color: #2a93ff;
                &::before {
                  transition: all 0.3s linear;
                  transform: translate(18px, 8px) scale(1, 1);
                }
              }
            }

            .tip1 {
              /deep/.ivu-poptip-popper {
                //display: block !important;
                width: 446px !important;
                padding: 0px;
                
              }
              /deep/.ivu-poptip-arrow {
                  display: none !important;
                }
                /deep/.ivu-poptip-inner {
                  box-shadow: 0 0px 0px rgba(0, 0, 0, 0.2);
                  border-radius: 0;
                  background: rgba(0, 14, 53, 0.7);
                }
              .child {
                display: flex;
                cursor: default;
                .left {
                  padding: 30px 60px 10px 50px;
                  width: 223px;
                }
                .right {
                  padding: 30px 0 10px 50px;
                  width: 223px;
                }
                .item {
                  text-align: left;
                  margin-bottom: 30px;
                  p {
                    font-size: 18px;
                    margin-bottom: 15px;
                    color: #fff;
                  }
                  a {
                    font-size: 14px;
                    line-height: 24px;
                    height: 24px;
                    color: #fff;
                  }
                }
              }
            }
            .tip2 {
              /deep/.ivu-poptip-popper {
                //display: block !important;
                width: 446px !important;
                padding: 0px;
              }
               /deep/.ivu-poptip-arrow {
                  display: none !important;
                }
               /deep/.ivu-poptip-inner {
                  box-shadow: 0 0px 0px rgba(0, 0, 0, 0.2);
                  border-radius: 0;
                  background: rgba(0, 14, 53, 0.7);
                }
              .child {
                display: flex;
                cursor: default;
                .left {
                  padding: 30px 60px 10px 50px;
                  width: 223px;
                }
                .right {
                  padding: 30px 0 10px 50px;
                  width: 223px;
                }
                .item {
                  text-align: left;
                  margin-bottom: 30px;
                  p {
                    font-size: 18px;
                    margin-bottom: 15px;
                    color: #fff;
                  }
                  a {
                    font-size: 14px;
                    line-height: 24px;
                    height: 24px;
                    color: #fff;
                  }
                }
              }
            }
          }
        }
        .prod {
          position: relative;
          .a {
            .over {
              position: absolute;
              background: rgba(0, 0, 0, 1);
              opacity: 0;
            }
            .overcn {
              top: -6px;
              left: -24px;
              width: 140px;
              height: 96px;
            }
            .overen {
              top: -6px;
              left: -23px;
              width: 190px;
              height: 96px;
            }
          }

          .a:hover .over {
            opacity: 0.1;
          }
          .p1 {
            //padding: 32px 0;
            font-size: 18px;
            font-weight: 400;

            color: rgba(255, 255, 255, 0.6);
            &.a-cur {
              height: 92px;
              border-bottom: 3px solid #fff;
              color: rgba(255, 255, 255, 1);
            }
          }
          .api {
            height: 228px;

            text-align: center;

            p {
              height: 57px;
              cursor: pointer;
              a {
                display: inline-block;
                padding: 18px 0 0 0;
                height: 100%;
                width: 100%;
                font-size: 18px;
                font-weight: 400;
                color: rgba(68, 68, 68, 1);
              }
              a:hover {
                color: rgba(58, 136, 247, 1);
                background: rgba(44, 166, 224, 0.08);
              }
            }
          }
          /deep/.ivu-poptip-popper {
            top: 87px !important;
          }
          /deep/.ivu-poptip-inner {
            border-radius: 0;
          }
        }
      }
    }

    .lang {
      width: 80px;
      margin-left: 20px;
      .langcn {
        display: inline-block;
        height: 70px;
        line-height: 70px;
        font-size: 18px;
        font-weight: 400;
        cursor: pointer;
        .cn {
          color: rgba(42, 147, 255, 1);
        }
        .en {
          color: #444444;
          &:hover {
            color: rgba(42, 147, 255, 1);
          }
        }
        .xg {
          margin: 0 10px;
          color: #444444;
        }
      }
      .langen {
        display: inline-block;
        vertical-align: middle;
        font-size: 18px;
        line-height: 70px;
        font-weight: 400;
        cursor: pointer;
        .en {
          color: rgba(42, 147, 255, 1);
        }
        .cn {
          color: #444444;
          &:hover {
            color: rgba(42, 147, 255, 1);
          }
        }
        .xg {
          margin: 0 10px;
          color: #444444;
        }
      }
    }
  }
}
.ivu-input {
  font-size: 12px;
}
.white-color {
  color: #fff;
}
//控制下拉菜单
// /deep/.ivu-poptip-popper {
//   display: block !important;
// }
/deep/.ivu-poptip-body {
  padding: 0;
}
</style>
